export default __webpack_public_path__ + "static/media/bg26.d701ccfe.jpg";